import "@/i18n/config";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import editURL from "@assets/icons/edit.svg";

import {
  getCoachingChecklist,
  updateCoaching,
} from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { PrimaryButton, SecondaryButton } from "@/ui/buttons";

interface Props {
  positionId: string;
  inAdmin?: boolean;
}

interface Item {
  name: string;
  id: string;
  addressed_date: string;
  document_url: string;
  document?: File | string | null;
  content: string;
}

const inputDefault: Item = {
  name: "",
  id: "",
  addressed_date: "",
  document_url: "",
  content: "",
};
export function Coaching(props: Props) {
  const { positionId, inAdmin } = props;
  const [list, setList] = useState<Item[]>([]);
  const [inputItem, setInput] = useState<Item>(inputDefault);
  const [itemIndex, setItemIndex] = useState<number | null>(null);
  useEffect(() => {
    if (positionId) {
      getCoachingChecklist(positionId, inAdmin)
        .then((response) => response.json())
        .then((data) => {
          setList(data.coachings);
        });
    }
  }, [positionId]);

  const handleInputChange = (key: string, value: any) => {
    setInput((prevState) => ({ ...prevState, [key]: value }));
  };

  const handleSave = () => {
    const formData = new FormData();

    formData.append("coaching[record_id]", inputItem.id);
    formData.append("coaching[addressed_date]", inputItem.addressed_date);
    formData.append("coaching[name]", inputItem.name);
    formData.append("coaching[content]", inputItem.content || "");
    if (inputItem.document) {
      formData.append("coaching[document]", inputItem.document);
    }

    updateCoaching(positionId, formData, inAdmin)
      .then((response) => response.json())
      .then((data) => {
        setList((prevData) => {
          const updatedData = [...prevData];
          updatedData[itemIndex] = {
            ...updatedData[itemIndex],
            ...data,
          };
          return updatedData;
        });

        setItemIndex(null);
        setInput(inputDefault);
      });
  };

  return (
    <div className='flex justify-between space-x-8'>
      <div className='w-full max-w-[700px]'>
        {list.map(({ name, content, addressed_date, document_url }, index) => (
          <div className='pb-4' key={index}>
            <div className='pb-1 flex justify-between'>
              <div className='text-xl font-bold '># {name} </div>
              {!inAdmin && (
                <div className='tooltip border-0 cursor-pointer pt-2'>
                  <SVG
                    src={editURL}
                    className='icon-sm fill-current ml-2 cursor-pointer'
                    onClick={() => {
                      setItemIndex(index);
                      setInput(list[index]);
                    }}
                  />
                  <span className='tooltiptext min-w-[50px] ml-0 left-0'>
                    Edit
                  </span>
                </div>
              )}
            </div>
            <div className='border border-neutral-300 rounded p-2'>
              <table className='w-full text-left border-separate table-auto'>
                <colgroup>
                  <col style={{ width: "25%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>Dated Completed</td>
                    <td>
                      {" "}
                      {addressed_date &&
                        new Date(addressed_date).toLocaleDateString("en-GB")}
                    </td>
                  </tr>
                  <tr>
                    <td>Document</td>
                    <td>
                      {document_url && (
                        <a
                          href={document_url}
                          target='_blank'
                          className='underline'
                        >
                          Attached
                        </a>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Content</td>
                    <td>{content}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
      {!inAdmin &&
        (itemIndex == null ? (
          <PrimaryButton
            label='Add new'
            onClick={() => {
              setItemIndex(list.length);
              setInput(inputDefault);
            }}
          />
        ) : (
          <div className='max-w-xl rounded-md shadow-md w-[500px] p-4'>
            <div>
              <label>Name</label>
              <input
                type='text'
                className='form-control'
                value={inputItem.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
              />
            </div>
            <div>
              <label>Content</label>
              <input
                type='text'
                className='form-control'
                value={inputItem.content}
                onChange={(e) => handleInputChange("content", e.target.value)}
              />
            </div>
            <div>
              <label>Date Completed</label>
              <input
                type='date'
                className='form-control'
                value={inputItem.addressed_date}
                onChange={(e) =>
                  handleInputChange("addressed_date", e.target.value)
                }
              />
            </div>
            <div>
              <label>Document Attached</label>
              <input
                type='file'
                accept='.pdf,.doc,.docx,.jpg,.png'
                className='form-control'
                onChange={(e) =>
                  handleInputChange("document", e.target.files?.[0] || null)
                }
              />
            </div>
            <div className='flex justify-between'>
              <SecondaryButton
                label='Cancel'
                onClick={() => {
                  setItemIndex(null);
                  setInput(inputDefault);
                }}
              />
              <PrimaryButton
                label='Save'
                disabled={!inputItem.name || !inputItem.addressed_date}
                onClick={handleSave}
              />
            </div>
          </div>
        ))}
    </div>
  );
}
